<template>
  <b-container fluid id="wrapper-login" class="p-0" :style="{ backgroundImage: `url(${bgImage})` }">
    <b-row no-gutters>
      <b-col class="col-left hv-100" v-bind:style="{ background: loginBgColor, textAlign: loginTextAlign  }">
        <router-link to="/" class="d-flex" v-bind:style="{ justifyContent: loginLogoJustifyContent }">
          <b-img :src="logoHomeImg" fluid alt="Logo" v-bind:style="{ width: loginLogoWidth }" class="logoSite"/>
        </router-link>
        <div v-if="authMode === 'session'">
          <h4 class="mt-4">{{ $t('password_restore_title')}}</h4>
          <div v-if="restoredPasswordSuccessfully" class="mt-3">
            <p>
              {{ $t('password_updated_successfully_msg')}}
            </p>
          </div>
          <div v-else>
            <LmComponentLoading v-if="loading"/>
            <LmPassword
              @enter="saveNewPassword"
              v-model="form.newPassword"
              :v="$v.form.newPassword"
              :serverErrorMessage="serverErrorMessage"
              :label="$t('password')"
              />
            <LmPassword
            @enter="saveNewPassword"
            v-model="form.newPasswordAgain"
            :v="$v.form.newPasswordAgain"
            :serverErrorMessage="serverErrorMessage"
            :label="$t('password_again')"
            />
            <button
              autofocus
              id="session-is-authenticated-else"
              class="btn btn-primary btn-margin mt-3 buttonLogin"
              @click="saveNewPassword"
            >
              <i class="mdi mdi-login"></i>
              {{ $t('restore_password_button_msg')}}
            </button>
          </div>
        </div>
      </b-col>
      <b-col class="col-right hv-100 d-none d-xl-block">
        <div class="auth-user-testimonial">
          <h2 class="mb-3">{{ title1 }}</h2>
          <p class="lead">
            <i class="mdi mdi-format-quote-open"></i>
            {{ text }}
            <i class="mdi mdi-format-quote-close"></i>
          </p>
          <p>{{ title2 }}</p>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmPassword from '@/components/form/elements/LmPassword'
import { mapState, mapGetters, mapActions } from 'vuex'
import { required, sameAs } from 'vuelidate/lib/validators'
import commonsApi from '@/api/commons'
import lmToasts from '@/mixins/lmToasts.js'

export default {
  name: 'app',
  components: {
    LmTextInput,
    LmPassword
  },
  mixins: [lmToasts],
  data () {
    return {
      form: {
        newPassword: '',
        newPasswordAgain: ''
      },
      serverErrorMessage: '',
      loading: false,
      restoredPasswordSuccessfully: false
    }
  },
  validations: {
    form: {
      newPassword: {
        required
      },
      newPasswordAgain: {
        sameAsNewPassword: sameAs('newPassword')
      }
    }
  },
  methods: {
    ...mapActions('notifications', ['getNotifications']),
    async saveNewPassword () {
      this.$v.$touch()
      if (!this.$v.form.$invalid) {
        this.loading = true
        try {
          await commonsApi.axiosPutWrapper(
            process.env?.VUE_APP_RESTORE_PASSWORD_URL + this.$route.query.token,
            {
              new_password: this.form.newPassword,
              new_password_again: this.form.newPasswordAgain
            }
          )
          this.restoredPasswordSuccessfully = true
          setTimeout(() => {
            this.$router.push('/login')
          }, 3000)
        } catch (err) {
          this.lmToastDangerMessage(err.response.data.message, `${err.response.data.type} - ${err.response.data.code}`)
        } finally {
          this.loading = false
        }
      }
    }
  },
  computed: {
    ...mapGetters('session', ['isAuthenticated']),
    ...mapState('settings', ['appName', 'logoHomeImg', 'title1', 'title2', 'text', 'bgImage', 'loginBgColor', 'loginLogoWidth', 'loginLogoJustifyContent', 'loginTextAlign']),
    authMode () {
      return process.env.VUE_APP_AUTH_MODE
    }
  },
  created () {
    if (this.isAuthenticated) {
      this.$router.replace('/')
    }
  },
  mounted () {
    this.$bvToast.hide('lm-toast-success-internal-link')
  }
}
</script>

<style lang="sass" scoped>
#wrapper-login
  background-position: center
  background-size: cover
  .col-left
    padding: 48px 55px
    max-width: 480px
    width: 100%
    @media(max-width: $xl)
      max-width: none
      padding: 72px 56px
    .logoSite
      @media(max-width: $xl)
        margin: 0 auto
        display: block
    h4
      font-size: 18px
      font-weight: 700
      color: $primaryFontThemeColor
    p
      color: $mutedFontThemeColor!important
      font-size: 14px
      font-weight: 400
    .buttonLogin
      box-shadow: 0 2px 6px 0 rgba(114,124,245,.5)
      width: 100%
      color: #fff
      font-size: 14px
      font-weight: 400
  .col-right
    padding: 6rem 3rem
    -webkit-box-flex: 1
    -ms-flex: 1
    flex: 1
    position: relative
    color: #fff
    background-color: rgba(49,58,70,.6)
    text-align: center
    .auth-user-testimonial
      position: absolute
      margin: 0 auto
      padding: 0 1.75rem
      bottom: 3rem
      left: 0
      right: 0
      h2
        font-weight: 700
      p
        font-size: 14px
        &.lead
          font-weight: 400
          font-size: 18px
  .footer
    bottom: 0
    padding: 19px 30px 20px
    position: absolute
    right: 0
    color: $mutedFontThemeColor
    width: 100%
    text-align: center
</style>
